<template>
    <v-btn
        plain
        :ripple="false"
        absolute
        class="ma-6 top-0 right-0"
        :value="value"
        @click="$emit('input', !value)"
    >
        <v-icon :color="value ? 'primary' : 'secondary'">list</v-icon>
        <small class="ml-2">
            {{ value ? option1 : option2 }}
        </small>
    </v-btn>
</template>

<script>
export default {
    props: ["option1", "option2", "value"],
};
</script>
